<script>
export default {
  props: {
    rows: {
      default: null,
      type: Array,
    },
  },
}
</script>

<template>
  <table>
    <tr v-for="row in rows" :key="row.id">
      <td v-for="data in row" :key="data.id" :style="row.length < 2 ? `border-left: 0;` : ``">
        <b-col v-if="data.type === 0" class="tableData" lg="12">
          <div class="titleDiv">{{ data.title }}</div>
          <div class="descriptionDiv">{{ data.description }}</div>
        </b-col>
        <b-col v-if="data.type === 1" class="tableData" lg="12">
          <div class="rightBorder" :style="`background-color:${data.color}`"></div>
          <div class="titleDiv" :style="`color:${data.color}`">{{ data.title }}</div>
          <div class="descriptionDiv" :style="`color:${data.color}`">{{ data.description }}</div>
        </b-col>
        <b-col v-if="data.type === 2" class="tableData" lg="12">
          <div class="titleDiv">{{ data.title }}</div>
          <div>
            <img :src="data.image" />
          </div>
        </b-col>
        <b-col v-if="data.type === 3" class="tableData" lg="12">
          <div class="titleDiv">{{ data.title }}</div>
          <div class="descriptionTyoe3" :style="`background-color:${data.backgroundColor}; color:${data.color}`">
            {{ data.description }}
          </div>
        </b-col>
        <b-col v-if="data.type === 4" class="tableData" lg="12">
          <div class="titleDiv">{{ data.title }}</div>
          <div class="descriptionDiv">{{ Commafy(data.description) }} تومان</div>
        </b-col>
        <b-col v-if="data.type === 5" class="tableData" lg="12">
          <div class="titleDiv">{{ data.title }}</div>
          <div class="descriptionDiv">{{ Commafy(data.description) }}</div>
        </b-col>
        <b-col v-if="data.type === 6" class="tableData" lg="12">
          <div class="titleDiv">{{ data.title }}</div>
          <div class="descriptionDiv">{{ convertToDateAndTime(data.description) }}</div>
        </b-col>
        <b-col v-if="data.type === 7" class="tableData" lg="12">
          <div class="titleDiv">{{ data.title }}</div>
          <div class="descriptionDiv" :style="`color:${data.color}`">{{ data.description }}</div>
        </b-col>
        <b-col v-if="data.type === 8" class="tableData flex-column" lg="12">
          <img class="img-fluid image-style" :src="data.description" />
          <div class="titleDiv">{{ data.title }}</div>
        </b-col>
        <b-col v-if="data.type === 9" class="tableData flex-column" lg="12">
          <video style="height: 200px" class="w-100 borderRdius" controls>
            <source :src="data.description" type="video/mp4" />
          </video>
          <div class="titleDiv">{{ data.title }}</div>
        </b-col>
        <b-col v-if="data.type === 20" class="tableDataUpload" lg="12">
          <div class="titleDiv">{{ data.title }}:</div>
          <div class="d-flex align-items-center" v-for="(item, indexx) in data.description" :key="indexx">
            <a :href="item.url">
              <div class="me-2" v-if="item.type == 'image/png' || item.type == 'image/jpg' || item.type == 'image/jpeg'">
                <img style="width: 40pt" :src="item.url" alt="image" />
              </div>
              <div class="me-2" v-else-if="item.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'">
                <i style="font-size: 40pt; color: green" class="fa-thin fa-file-excel"></i>
              </div>
              <div class="me-2" v-else-if="item.type == 'application/pdf'">
                <i style="font-size: 40pt; color: red" class="fa-thin fa-file-pdf"></i>
              </div>
              <div class="me-2" v-else-if="item.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'">
                <i style="font-size: 40pt; color: blue" class="fa-thin fa-file-word"></i>
              </div>
              <div class="me-2" v-else-if="item.type == 'application/x-zip-compressed'">
                <i style="font-size: 40pt; color: black" class="fa-thin fa-file-archive"></i>
              </div>
            </a>
          </div>
        </b-col>
      </td>
    </tr>
  </table>
</template>

<style lang="scss" scoped>
table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
}
table td {
  font-size: 12px;
  color: #555555;
  width: 50%;
  padding: 10px;
  height: 64px;
  border: 1px solid #ced4da;
}
table tr:first-child td {
  border-top: 0;
}
table tr td:first-child {
  border-right: 0;
}
table tr:last-child td {
  border-bottom: 0;
}
table tr td:last-child:nth-child(even) {
  border-left: 0;
}
.tableData {
  display: flex;
  width: 100%;
}
.tableDataUpload {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(2, 65px);
  grid-row-gap: 2px;
}
.titleDiv {
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.image-style {
  border-radius: 7px;
  width: 250px;
}
.descriptionDiv {
  display: flex;
  justify-content: center;
  align-items: center;
}
.rightBorder {
  margin-left: 10px;
  height: 33px;
  width: 2px;
}
.descriptionTyoe3 {
  padding: 5px 15px;
  border-radius: 3px;
}
</style>
